import { type SuggestedAction } from '../../types/ai';
import { maybeFixMojibake } from '../../utils/mojibake';

const OUTFIT_CHANGE_PREFIX = /^outfit_change:/i;

const humanizeOutfitChangeValue = (value: string): string => {
  const match = value.match(/^outfit_change:(.+)$/i);
  if (!match) return value;

  const cleaned = match[1].trim().replace(/[_-]+/g, ' ');
  if (!cleaned) return 'Byt plagg';
  if (cleaned.toLowerCase() === 'annat') return 'Byt plagg';

  return `Byt ${cleaned}`;
};

// Hjärnan lägger ibland maskinvärdet i label och texten i value. Kunden läser
// label och klicket skickar value, så ett obemärkt byte visar "outfit_change:kavaj"
// som knapptext och skickar en mening till hjärnan som den inte kan tolka.
export const repairSuggestedActions = (actions: SuggestedAction[]): SuggestedAction[] =>
  (actions ?? []).map((action) => {
    let label = maybeFixMojibake(String(action?.label ?? '')).trim();
    let value = maybeFixMojibake(String(action?.value ?? '')).trim();

    if (OUTFIT_CHANGE_PREFIX.test(label) && !OUTFIT_CHANGE_PREFIX.test(value)) {
      const swapped = label;
      label = value;
      value = swapped;
    }

    if (OUTFIT_CHANGE_PREFIX.test(label)) {
      label = humanizeOutfitChangeValue(label);
    }

    if (OUTFIT_CHANGE_PREFIX.test(value) && (!label || OUTFIT_CHANGE_PREFIX.test(label))) {
      label = humanizeOutfitChangeValue(value);
    }

    return {
      ...action,
      label,
      value,
      payload: action.payload,
    };
  });

// Förslagen kommer både som egen SSE-händelse och som markörer sist i texten.
// Missar vi att klippa markörerna hamnar de i chattbubblan som rå text.
export const stripSuggestedActionsMarkers = (text: string): string =>
  maybeFixMojibake(
    text.replace(/\[SUGGESTED_ACTIONS\][\s\S]*?\[\/SUGGESTED_ACTIONS\]\s*$/, '').trimEnd(),
  );
